'use strict';

/* global fbq */

var ga4 = require('./ga4');
var metaCapi = require('./metaCapi');

module.exports = {
    init: function () {
        var $product = $('.product-detail').first();
        if (!$product.length) {
            return;
        }

        var pid = $product.data('pid');
        if (!pid) {
            return;
        }

        var name = $product.find('.product-name').first().text().trim();
        var price = ga4.getFirstPriceValue($product);
        var currency = ga4.getCurrency();
        var category = $product.data('category') || '';

        ga4.sendEvent('view_item', {
            currency: currency,
            value: price,
            items: [
                {
                    item_id: String(pid),
                    item_name: name || String(pid),
                    price: price,
                    quantity: 1,
                    item_category: category
                }
            ]
        });

        var metaContentIds = [String(pid)];
        var metaContents = [{ id: String(pid), quantity: 1, item_price: price }];
        var metaPayload = {
            currency: currency,
            value: price,
            content_type: 'product',
            content_ids: metaContentIds,
            contents: metaContents
        };

        metaCapi.track('ViewContent', metaPayload);

        if (typeof fbq === 'function') {
            fbq('track', 'ViewContent', metaPayload);
        }
    }
};
